import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"border":"1px solid #ccc"}
}
const _hoisted_2 = { class: "card-header row d-flex justify-content-between align-items-center" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-star text-warning",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "overlay rounded overflow-hidden"
}
const _hoisted_7 = {
  key: 0,
  class: "overlay-layer"
}
const _hoisted_8 = { class: "text-left mb-md-0 mb-lg-5 mb-md-0 mb-5 d-flex flex-column" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "my-3" }, null, -1)
const _hoisted_12 = { class: "card-toolbar" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-right",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        class: "fw-bolder text-dark fs-3 my-3",
        innerHTML: _ctx.titleText
      }, null, 8, _hoisted_3),
      false
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _ctx.urlInfo,
            class: "btn btn-white btn-sm fw-bolder col"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "overlay-wrapper rounded bg-light text-center bgi-no-repeat bgi-size-cover",
              style: _normalizeStyle([{
            backgroundImage: 'url(' + _ctx.imageInfo + ')',
          }, {"min-height":"200px","border-radius":"0.5rem"}])
            }, null, 4),
            true
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: _ctx.urlInfo,
                    class: "btn fw-bolder btn-sm me-2"
                  }, null, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    to: _ctx.urlInfo,
                    class: "btn fw-bolder btn-sm btn-light-primary"
                  }, null, 8, ["to"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", {
          innerHTML: _ctx.subtitle,
          class: "fs-4 text-dark-800 mb-1"
        }, null, 8, _hoisted_9),
        _createElementVNode("span", {
          class: "lead text-dark-800",
          innerHTML: _ctx.bio
        }, null, 8, _hoisted_10)
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_router_link, {
          to: _ctx.urlInfo,
          class: "btn btn-lg btn-secondary mt-5"
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createTextVNode(" Começar ")
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}